import { bunja } from 'bunja';

import { authBunja } from '@flipster/features/src/shared/auth/state';
import { RouterScope } from '@flipster/react/providers/route';
import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';

export const authGuardBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const router = bunja.use(RouterScope);
  const { isLoggedInAtom } = bunja.use(authBunja);
  const guard = <T extends unknown[], R>(callback: (...args: T) => R): ((...args: T) => R | undefined) => {
    return (...args: T) => {
      const isLoggedIn = store.get(isLoggedInAtom);
      if (!isLoggedIn) {
        router.push('/signin');
        return;
      }
      return callback(...args);
    };
  };

  return { guard };
});
authGuardBunja.debugLabel = 'authGuardBunja';
